import {
    css, Theme,
} from '@emotion/react'
import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        root: custom.dashBoardRoot,
        main: css` width: 100% `,
        userLocationTitle: css` padding-bottom: 30px `,
        userLocationText: css`
            border-bottom: 1px solid ${theme.palette.primary.main};
            color: ${theme.typography.h3.color};
        `,
        dashboard: css` grid-template-columns: 1fr 1fr `,
    }
}

export default styles
